<template>
  <figure class="relative size-full overflow-hidden">
    <nuxt-img
      v-if="media.type === 'image' && media.src"
      :src="media.src"
      :alt="media.alt"
      :loading="isPriority ? 'eager' : 'lazy'"
      :fetchpriority="isPriority ? 'high' : 'auto'"
      sizes="xs:480px sm:640px lg:800px"
      class="absolute inset-0 size-full object-cover"
    />

    <video
      v-else-if="media.type === 'video' && media.src"
      :src="media.src"
      :poster="media.poster"
      :aria-label="media.alt"
      autoplay
      loop
      muted
      playsinline
      preload="metadata"
      class="absolute inset-0 size-full object-cover"
    />

    <div
      v-else
      class="absolute isolate inset-0 flex items-center justify-center bg-white"
    >
      <shape-trame />

      <icon
        :name="media.type === 'video' ? 'ph:play-circle-duotone' : 'ph:image-duotone'"
        aria-hidden="true"
        class="size-16 text-brand-500/80"
      />
    </div>

    <atomic-badge
      v-if="media.type === 'video'"
      label="Vidéo"
      class="absolute left-4 top-4 z-10 shadow-float"
    >
      <template #icon>
        <icon name="ph:play-fill" aria-hidden="true" class="size-3" />
      </template>
    </atomic-badge>

    <figcaption
      v-if="media.caption"
      class="absolute inset-x-0 bottom-0 bg-gradient-to-t from-gray-900/70 to-transparent p-4 pt-10 text-sm font-medium text-white"
    >
      {{ media.caption }}
    </figcaption>
  </figure>
</template>

<script setup lang="ts">
import type { TestimonialMedia } from 'types/testimonial'

type Props = {
  media: TestimonialMedia,
  isPriority?: boolean
}

const { media, isPriority = false } = defineProps<Props>()
</script>
